import client from "../modules/client";

export const verifyEventPaymentIntent = ({eventId, attendanceType}) => {
  return client(`/api/v0/payments/eventVerifyPaymentIntent`,
      {method: 'post', body: {eventID: eventId, eventAttendanceType: attendanceType}})
      .then(({ data }) => data);
};

export const createEventPaymentIntent = ({eventId, attendanceType}) => {
  return client(`/api/v0/payments/eventCreatePaymentIntent`,
      {method: 'post', body: {eventID: eventId, eventAttendanceType: attendanceType}})
      .then(({ data }) => data);
};

export const verifyTipPaymentIntent = ({eventId, price}) => {
  return client(`/api/v0/payments/tipVerifyPaymentIntent`,
      {method: 'post', body: {eventID: eventId, price: price}})
      .then(({ data }) => data);
};

export const createTipPaymentIntent = ({eventId, price}) => {
  return client(`/api/v0/payments/tipCreatePaymentIntent`,
      {method: 'post', body: {eventID: eventId, price: price}})
      .then(({ data }) => data);
};

export const userCardsList = (userId) => {
  return client(`/api/v0/payments/cards/${userId}`).then(({ data }) => data);
};

export const newUserCard = (userId) => {
  return client(`/api/v0/payments/cards/${userId}`,{method: 'post', body: {}}).then(({ data }) => data);
};

export const saveUserCard = (userId, paymentMethodId) => {
  return client(`/api/v0/payments/cards/${userId}`,{method: 'post', body: {paymentMethodID:paymentMethodId}}).then(({ data }) => data);
};

export const setDefaultPaymentMethod = (methodID) => {
  return client(`/api/v0/payments/setDefaultPaymentMethod`,
      {method: 'post', body: {paymentMethodID: methodID}})
      .then(({ data }) => data);
};

export const removePaymentMethod = (methodID) => {
  return client(`/api/v0/payments/removePaymentMethod`,
      {method: 'post', body: {paymentMethodID: methodID}})
      .then(({ data }) => data);
};

export function usePaymentService () {
  return {
    verifyEventPaymentIntent,
    createEventPaymentIntent,
    verifyTipPaymentIntent,
    createTipPaymentIntent,
    userCardsList,
    newUserCard,
    saveUserCard,
    setDefaultPaymentMethod,
    removePaymentMethod,
  };
}
